<style scoped>
  .card {
    border-radius: 0;
    cursor: pointer;
    border-bottom: 1px solid #F2F2F2;
    min-height: 60px;
    margin: 10px 0 10px 0;
    width: 100%;
  }
  
  .item-details {    
    background-color: white;    
    border-radius: 10px;
    margin: 0 0px 0 10px;
  padding: 5px 0 5px 0;
    width: 100%;
  }
  .like {    
    background-color:#faf9f9; 
    bottom:-10px; 
    box-shadow: 1px 2px #e0dede;    
    border-radius:10px;     
    font-size: 12px;
    height:17px; 
    padding-left:4px;
    position:absolute;     
    right:0px;        
    width:32px;  
  }
  .color-normal {
    color: #616772;
    /* font-weight: bold; */
  }
  .color-unlike {
    color: #2d8cf0;
    font-weight: bold;
  }
  .container-comment {
    padding: 5px 0 5px 0 !important;
  }
  .container-reply {
    border-left: 2px solid rgb(39, 5, 228);
    margin: 0px 0px 5px 50px !important;
  }  
  .avatar-margin {
    margin-left:5px;
  }
  .avatar-none {
    margin-left:0px;
  }  
</style>
<style>
  .post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-footer{
    padding: 0;
  }

  .post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-body{
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-header{
    padding: 0;
    border: 0;
  }

  .post-update-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-close{
    z-index: 9;
  }
</style>


<template>
  <div :ref="'comment'+item.id" class="flex-container direction-col" :class="(type=='comment') ? 'container-comment':'container-reply'">
    
    <Card class="order-1" :bordered="false" dis-hover :padding="0" style="background-color: transparent;">   
      <div class="direction-row">        
        <div class="order-1" :class="(type=='reply') ? 'avatar-margin': 'avatar-none'">
          <span class='pointer' @click="avatarClick(item.user)">
            <Avatar :size="(type=='comment') ? 'large':'small'" :src="userDisplayImage(item.user)"></Avatar>
          </span>          
        </div>

        <div class="order-2 item-details">

          <Dropdown placement="bottom-end" style="float:right; padding-right:10px;" v-if="$store.state.user.info.user_type !== 'guest'">
            <a style="color: black;padding-right:0px;">
              <Icon size="20" type="android-more-vertical"></Icon>
            </a>        
            <DropdownMenu slot="list">
              <DropdownItem v-show="item.user.id==currentUserId">
                <a @click="showDeleteComment(item.id, item.item_id)">Delete</a>
              </DropdownItem>
              <DropdownItem v-show="item.user.id!=currentUserId">
                <a @click="showReport(item.id)">Report this comment</a>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
            
          <div style="padding:0 10px 0 10px;">
            <span class='pointer' @click="avatarClick(item.user)">
              <b style="color:black;font-size:12px;"> {{ item.user.display_name }} </b>
            </span>
            <read-more style="font-size:12px !important;" more-str="read more" :text="item.content" less-str="read less" :max-chars="95"></read-more>
          </div>          
          <div v-if="item.likes.users.length>0" class="center like" @click="showLikeModal=true">
            <Icon style="color:#2d8cf0;" type="thumbsup" />
             <h5 style="padding-left:2px;">{{item.likes.users.length}}</h5>
          </div>

        </div>
      </div>
    </Card>

    <div class="order-2 direction-row" style="font-size:10px;" :style="(type=='comment') ? 'padding-left:60px;':'padding-left:44px;'">
      <timeago class="order-1 color-normal" :since="item.date_recorded"></timeago>
      <div v-if="type=='comment'" class="order-2">
        <a :id="item.id" v-if="$store.state.user.info.user_type !== 'guest' && youveLikeIt(item.id) && !isLiking" @click="likeComment(item.id,false, false)" class="order-2 color-unlike">&nbsp; &nbsp;&nbsp; &nbsp; Unlike</a>
        <a :id="item.id" v-else-if="$store.state.user.info.user_type !== 'guest' && !youveLikeIt(item.id) && !isLiking" @click="likeComment(item.id,true, false) && !isLiking" class="order-2 color-normal">&nbsp; &nbsp;&nbsp; &nbsp; Like</a>
        <a v-if="$store.state.user.info.user_type !== 'guest' && youveLikeIt(item.id) && isLiking" class="order-2" style="font-weight:bold;">&nbsp; &nbsp; Unliking...</a>
        <a v-else-if="$store.state.user.info.user_type !== 'guest' && !youveLikeIt(item.id) && isLiking" class="order-2" style="font-weight:bold;">&nbsp; &nbsp; Liking...</a>
      </div>
      <div v-else class="order-2">
        <a :id="item.item_id" v-if="$store.state.user.info.user_type !== 'guest' && youveLikeIt(item.item_id) && !isLiking" @click="likeComment(item.id,false, true)" class="order-2 color-unlike">&nbsp; &nbsp;&nbsp;&nbsp; Unlike</a>
        <a :id="item.item_id" v-else-if="$store.state.user.info.user_type !== 'guest' && !youveLikeIt(item.item_id) && !isLiking" @click="likeComment(item.id,true, true) && !isLiking" class="order-2 color-normal">&nbsp; &nbsp;&nbsp;&nbsp; Like</a>
        <a v-if="$store.state.user.info.user_type !== 'guest' && youveLikeIt(item.item_id) && isLiking" class="order-2" style="font-weight:bold;">&nbsp; &nbsp; Unliking...</a>
        <a v-else-if="$store.state.user.info.user_type !== 'guest' && !youveLikeIt(item.item_id) && isLiking" class="order-2" style="font-weight:bold;">&nbsp; &nbsp; Liking...</a>        
      </div>

      <a v-if="type=='comment' && $store.state.user.info.user_type !== 'guest'" :id="item.id"
        @click="addReply(item.id,item.user.display_name)"
        class="order-3 color-normal">
        &nbsp; &nbsp; &nbsp; &nbsp; Reply
      </a>
    </div>   

    <slot></slot>

    <ModalHolder m-top="30" :title="''" :is-show="showLikeModal" :mWidth="'90%'"
        :mHeight="'75vh'" :closable="false" @on-close="showLikeModal=false" className="post-update-modal">
      <template slot="mheader">         
      </template>
      <template slot="mcontent">        
        <LikeComponent :users="item.likes.users"></LikeComponent>
      </template>
    </ModalHolder>    

  </div>  
</template>


<script>
import _ from 'lodash'
import Utils from '@/utils.js'
import ModalHolder from '@/components/ModalHolderComponent';
import LikeComponent from '@/components/LikeComponent';
import { Message } from "iview";
import { mapGetters } from "vuex"

export default {
  name: 'PostComponent',
  components: { ModalHolder, LikeComponent },
  props: {
    index: { type: Number, required: true },
    type: { type: String, required: false, default: 'comment' },
    item: { type: Object, required: true }
  },
  data() {
    return {
      isLiking: false,
      showLikeModal: false,
      likes: [],
    }
  },
  created() {
    this.eventEmitter();
  },
  computed: {
    ...mapGetters("user", ["isBroadcast"]),
    youveLikeIt: function() {
      return function(id) {
        var likeFound = _.find(this.item.likes.users,['id', this.currentUserId]);
        return likeFound!=undefined;
      }
    },    
    currentUserId: {
      get() {
        return this.$store.state.user.info.id;        
      }
    }
  },
  methods: {
    eventEmitter: function() {
      BroadcastEvent.$on('closeLikeModal', ()=> {
        this.showLikeModal=false;
      });
      BroadcastEvent.$on('onActivityLikes', (data)=> {

      });
    },
    addReply: function(id,name) {
      BroadcastEvent.$emit('onReplyClickShow', { id:id,name:name });
    },
    showReport: function(commentid) {      
      this.$store.commit('user/setReportThisId', commentid);
      this.$store.commit('user/setShowStepsComment', true);
    },     
    likeComment(id, isLike, isReply) {
      var param = { id:id, isLike:isLike, isReply:isReply };
      this.isLiking = true;
      this.$store.dispatch("feed/likeFeedSingleComment", param).then(
        res=>{
          if (!isLike) { // remove like from comment.
            var index = this.item.likes.users.map(
                          function(x) { return x.id; }
                        ).indexOf(this.currentUserId);
            this.item.likes.users.splice(index, 1);
          }

          this.isLiking=false;
        },
        error=>{
          this.isLiking=false;
        }
      );
    },    
    deleteComment: function(id, item_id) {
      this.$store.dispatch("feed/deleteFeedSingleComment", { id:id, item_id: item_id }).then(
        res=>{        

        }
      );      
    },
    showDeleteComment: function(id, item_id) {
      this.$Message({
        closable: true,
        title: { content:'Confirm' },
        icon: 'ios-trash',
        message: { content: 'Are you sure you want to permanently remove this comment from this app?' },
        buttons: [
          { label: 'Delete', type: 'error', hideAfter:true, action: ()=> this.deleteComment(id, item_id) },
          { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });     
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    avatarClick(v) {
      if (this.isBroadcast) {
        Message.warning("Unable to display user profile")
      }
      else {
       this.$store.commit("base/setShowProfileModal", true)
       this.$store.commit("base/setShowProfileInfo", v)
      }
    }
  }
}

</script>
